module.exports = __webpack_public_path__ + "static/media/demerdelta-life-natura2000-vertical.24dc2a38.png";